import { QueryClient } from '@tanstack/react-query';

/**
 * 轮询而不是 WebSocket。
 *
 * 这个系统的数据不要求秒级 —— 指标按天变化，待决事项按小时变化。
 * 引入长连接要处理心跳、重连、多副本下的广播，换来的收益接近于零。
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 刷新间隔的一半 —— 避免切页即重新请求
      staleTime: 30_000,
      refetchInterval: 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
